import { useEffect, useState } from 'react'
import { useNotification } from 'hooks/use-notification/useNotification'
import { Button as MuiButton, Box, Radio, Divider, Typography, Select as MuiSelect } from '@material-ui/core'
// @ts-ignore
import { useTheme } from 'styled-components'
import { Link, useHistory } from 'react-router-dom'
import { MainContainer } from 'components/page/containers/MainContainer'
import { Logo, LogoSize } from 'components/page/logo'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { BackendUser } from 'common/types'
import { useUserApi } from 'hooks/use-user-api/useUserApi'
import { SummitTicketConfirmation } from 'pages/summit/components/registration/SummitTicketConfirmation'
import { useEvents } from 'pages/content/components/events/hooks/useEvents'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'
import { Bfutr2023TicketConfirmationModal } from 'pages/summit/bfutr2023/components/Bfutr2023TicketConfirmationModal'
import { ReactComponent as Arrow } from '../summit/bfutr2023/assets/Inside_CTA_arrow.svg'
import { useThemeSwitch } from 'hooks/theme'
import { ModeSwitch } from 'common/atoms/ModeSwitch/ModeSwitch'
import { FancySwitch } from 'common/atoms/FancySwitch/FancySwitch'
import { Button } from 'common/atoms/Button/Button'
import { Pill } from 'common/atoms/Pill/Pill'
import { ReactComponent as Home } from 'icons/home.svg'
import { ReactComponent as Filter } from 'icons/filter.svg'
import { DemoContentWrapper } from './DemoContentWrapper'
import { InputFieldGroup } from 'common/molecules/InputFieldGroup/InputFieldGroup'
import { Select } from 'common/molecules/Select/Select'
import { GlobeIcon } from 'common/icon-components/GlobeIcon'
import { MobileBackButton } from 'common/atoms/MobileBackButton/MobileBackButton'

const Demo = () => {
  const { notify } = useNotification()
  const [logoSize, setLogoSize] = useState<LogoSize>('x-small')
  const [show, setShow] = useState(false)
  const handleChange = (e: any) => {
    setLogoSize(e.target.value)
  }
  const history = useHistory()
  const { backendUser } = useAuth()
  const { fetchUser } = useUserApi()
  const [connectUser, setConnectUser] = useState<BackendUser>()
  const { mode, switchTheme } = useThemeSwitch()
  const [checked, setChecked] = useState(false)
  const [selectValue, setSelectValue] = useState('')

  useEffect(() => {
    const getConnectUserById = async (ownerId: string) => {
      const user: BackendUser = await fetchUser(ownerId)
      if (user) {
        setConnectUser(user)
      }
    }
  }, [])

  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const { currentEvent } = useEvents(false, 'summit')
  const { inviteUsersByEmail } = useOnboarding()

  return (
    <>
      <MainContainer inviteUsersByEmail={inviteUsersByEmail} title="Demo" user={backendUser}>
        <Box width="100%" height="100%" bgcolor={theme.colors.supplementary} padding="0 2rem">
          <DemoContentWrapper title="Drop downs">
            <Box p="10px 0" width="25%" display="flex" flexDirection="column" gridGap="1rem">
              <Typography variant="h3">Default</Typography>
              <Select
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                label="Label name"
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                infoText="informational text"
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
              <Typography variant="h3">No Info text</Typography>

              <Select
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                label="Label name"
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />

              <Typography variant="h3">No info text & no Label</Typography>
              <Select
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
              <Typography variant="h3">No info text, no Label no icon</Typography>
              <Select
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
              <Typography variant="h3">Disabled</Typography>
              <Select
                disabled
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                label="Label name"
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                infoText="informational text"
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
            </Box>
          </DemoContentWrapper>

          <DemoContentWrapper title="Drop downs (Small)">
            <Box p="10px 0" width="25%" display="flex" flexDirection="column" gridGap="1rem">
              <Typography variant="h3">Default</Typography>
              <Select
                design="small"
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                label="Label name"
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                infoText="informational text"
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
              <Typography variant="h3">No Info text</Typography>

              <Select
                design="small"
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                label="Label name"
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />

              <Typography variant="h3">No info text & no Label</Typography>
              <Select
                design="small"
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
              <Typography variant="h3">No info text, no Label no icon</Typography>
              <Select
                design="small"
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
              <Typography variant="h3">Disabled</Typography>
              <Select
                design="small"
                disabled
                defaultValue={''}
                multiline={false}
                native={false}
                value={selectValue}
                label="Label name"
                placeholder="Select Option"
                required
                menuItemList={[
                  { label: 'label1', value: 'value1' },
                  { label: 'label2', value: 'value2' },
                  { label: 'label3', value: 'value3' },
                  { label: 'label4', value: 'value4' }
                ]}
                theme={theme}
                width="100%"
                startAdornment={
                  <Box paddingRight={'0.75rem'}>
                    <GlobeIcon fill={theme.colors.accent} />
                  </Box>
                }
                infoText="informational text"
                onChange={evt => {
                  setSelectValue(evt?.target?.value as any)
                }}
              />
            </Box>
          </DemoContentWrapper>

          <DemoContentWrapper title="Inputs Small">
            <Box p="10px 0" width="25%" display="flex" flexDirection="column" gridGap="1rem">
              <InputFieldGroup
                label="Normal Input no value"
                showCounter
                placeholder="Please input text here"
                helperText="This is normal input without text"
                design="small"
              />
              <InputFieldGroup
                label="Input with value"
                showCounter
                placeholder="Please input text here"
                value="This has a value"
                helperText="This input has a value"
                design="small"
              />
              <InputFieldGroup
                label="Disabled Input"
                showCounter
                placeholder="Please input text here"
                value="This has been disabled"
                helperText="This input is disabled"
                design="small"
                disabled
              />
              <InputFieldGroup
                label="Input with error"
                showCounter
                placeholder="Please input text here"
                value="This has an error"
                helperText="This input has an error"
                design="small"
                error
              />
            </Box>
          </DemoContentWrapper>

          <DemoContentWrapper title="Inputs">
            <Box p="10px 0" width="25%" display="flex" flexDirection="column" gridGap="1rem">
              <InputFieldGroup
                label="Normal Input no value"
                showCounter
                placeholder="Please input text here"
                helperText="This is normal input without text"
              />
              <InputFieldGroup
                label="Input with value"
                showCounter
                placeholder="Please input text here"
                value="This has a value"
                helperText="This input has a value"
              />
              <InputFieldGroup
                label="Disabled Input"
                showCounter
                placeholder="Please input text here"
                value="This has been disabled"
                helperText="This input is disabled"
                disabled
              />
              <InputFieldGroup
                label="Input with error"
                showCounter
                placeholder="Please input text here"
                value="This has an error"
                helperText="This input has an error"
                error
              />
            </Box>
          </DemoContentWrapper>

          <DemoContentWrapper title="Switches">
            <Typography variant="h3">Large Switches</Typography>
            <ModeSwitch
              mode={mode == 'dark' ? 'light' : 'dark'}
              onChange={mode => {
                switchTheme()
              }}
            />
            <FancySwitch
              currentStateLabel={isOn => <>{isOn ? 'ON' : 'OFF'}</>}
              state={checked}
              onChange={isOn => {
                setChecked(isOn)
              }}
            />
            <Typography variant="h3">Small Switches</Typography>
            <FancySwitch
              currentStateLabel={isOn => <>{isOn ? 'ON' : 'OFF'}</>}
              state={checked}
              onChange={isOn => {
                setChecked(isOn)
              }}
              small
            />
          </DemoContentWrapper>

          <DemoContentWrapper title="Buttons">
            <Box margin="2em">
              <Button
                design="primary"
                rightIcon={<Home fill={'#EEEEEE'} />}
                onClick={() => notify('info', 'Hello There')}
              >
                Label
              </Button>
            </Box>
            <Box margin="2em">
              <Button design="primary" disabled forwardArrowIcon onClick={() => notify('info', 'Hello There')}>
                Disabled
              </Button>
            </Box>
            <Box margin={'2em'}>
              <Button design="primary" small onClick={() => notify('info', 'Hello There')}>
                Label
              </Button>
            </Box>
            <Box margin={'2em'}>
              <Button design="primary" small backArrowIcon onClick={() => notify('info', 'Hello There')}>
                Label
              </Button>
            </Box>
            <Box margin="2em">
              <Button design="secondary" disabled onClick={() => notify('info', 'Hello There')}>
                Disabled
              </Button>
            </Box>
            <Box margin="2em">
              <Button design="secondary" small forwardArrowIcon onClick={() => notify('info', 'Hello There')}>
                Label
              </Button>
            </Box>
            <Box margin="2em">
              <Button backArrowIcon design="secondary" onClick={() => notify('info', 'Hello There')}>
                Back
              </Button>
            </Box>
            <Box margin="2em">
              <Button design="tertiary" onClick={() => notify('info', 'Hello There')}>
                Label
              </Button>
            </Box>
            <Box margin="2em">
              <Button design="tertiary" forwardArrowIcon onClick={() => notify('info', 'Hello There')}>
                Label
              </Button>
            </Box>
            <Box margin="2em">
              <Button design="tertiary" showBorder onClick={() => notify('info', 'Hello There')}>
                With Border
              </Button>
            </Box>
            <Box margin="2em">
              <Button design="tertiary" disabled showBorder onClick={() => notify('info', 'Hello There')}>
                Disabled
              </Button>
            </Box>
            <Typography variant="h3">Mobile Back Button</Typography>
            <Box margin="0 2em">
              <MobileBackButton onClick={() => history.goBack()} />
            </Box>
          </DemoContentWrapper>

          <DemoContentWrapper title="Pills">
            <Box display={'flex'} flexWrap={'wrap'} alignItems={'center'} gridGap={'1rem'} m="1rem">
              <Pill icon={<Filter width="16px" />} text="CA$ 65,000 - 75,000 Annually" />
              <Pill text="CA$ 65,000 - 75,000 Annually" />
            </Box>

            <Box>
              <Pill text="This is a pill" small />
              <Pill text="This is a small" small />
            </Box>
          </DemoContentWrapper>

          <DemoContentWrapper title="Uncategorised">
            <Box padding="0 1em">
              {/* Madiha's component */}
              <MuiButton
                variant="contained"
                onClick={
                  () => {}
                  // sendConnectionRequest(connectUser)
                }
              >
                Send Connection Request
              </MuiButton>
              <MuiButton color="primary" variant="outlined" onClick={() => setShow(true)}>
                Open ticket confirmation
              </MuiButton>
              <Bfutr2023TicketConfirmationModal show={show} onClose={() => setShow(false)} />
              <MuiButton variant="contained" color="secondary" onClick={() => history.push('/bfutr2023/confirmation')}>
                Route to confirmation page
              </MuiButton>

              {/* <PartnerOnBoardingQuestions onSubmit={completeOnboarding} user={backendUser} /> */}
              {/*Notifications*/}
              <Box width="50%" m="1em">
                <MuiButton color="primary" variant="contained" onClick={() => notify('info', 'Hello There')}>
                  Notify
                </MuiButton>
              </Box>
              <SummitTicketConfirmation
                show={false}
                theme={theme}
                event={currentEvent}
                onClose={() => setShow(false)}
                isDevice={isDevice}
              />
              <Box width="50%" m="1em">
                <MuiButton color="primary" variant="outlined" onClick={() => notify('error', 'This is an error!!')}>
                  Error
                </MuiButton>
              </Box>
              <Box width="50%" m="1em">
                <MuiButton color="primary" variant="contained" onClick={() => notify('warning', 'This is a warning')}>
                  Warning
                </MuiButton>
              </Box>
              <Box width="50%" m="1em">
                <MuiButton color="primary" variant="outlined" onClick={() => notify('success', 'This is a success!!')}>
                  Success
                </MuiButton>
              </Box>
              {/*Logo*/}
              <Box m="1em" display="flex" flexDirection="column" flexGrow={1}>
                <Box display="flex" flexDirection="row">
                  <Radio
                    checked={logoSize === 'x-small'}
                    onChange={handleChange}
                    value="x-small"
                    name="radio-button-demo"
                    inputProps={{ 'aria-label': 'X-Small' }}
                    size="small"
                  />
                  <Radio
                    checked={logoSize === 'small'}
                    onChange={handleChange}
                    value="small"
                    name="radio-button-demo"
                    inputProps={{ 'aria-label': 'Small' }}
                    size="small"
                  />
                  <Radio
                    checked={logoSize === 'medium'}
                    onChange={handleChange}
                    value="medium"
                    name="radio-button-demo"
                    inputProps={{ 'aria-label': 'Medium' }}
                    size="small"
                  />
                  <Radio
                    checked={logoSize === 'large'}
                    onChange={handleChange}
                    value="large"
                    color="primary"
                    name="radio-button-demo"
                    inputProps={{ 'aria-label': 'Large' }}
                    size="small"
                  />
                  <Radio
                    checked={logoSize === 'x-large'}
                    onChange={handleChange}
                    value="x-large"
                    color="primary"
                    name="radio-button-demo"
                    inputProps={{ 'aria-label': 'X-Large' }}
                    size="small"
                  />
                </Box>
                <Logo size={logoSize} />
              </Box>
              <Box width="50%" m="1em">
                <Link to="/onboarding">Onboarding</Link>
              </Box>
              <Box width="50%" m="1em">
                <Link to="/dashboard">Dashboard</Link>
              </Box>
            </Box>
          </DemoContentWrapper>
        </Box>
      </MainContainer>
    </>
  )
}
export default Demo
